// Services Imports
import { getAllPricebooksService } from "./opportunitiesService";
import { generateDocumentID } from "../QuotesActions/QuotesService";

// export const getAllAccountsByUser = () => dispatch => {
//   fetchAllAccountsByUser()
//     .then(response => {
//       // console.debug(response);
//       dispatch({
//         type: "ACCOUNTS_BY_USER",
//         payload: response.Accounts,
//       });
//     })
//     .catch(error => {
//       console.error(error);
//     });
// };

// export const getAllOpportunitiesByAccount = accountID => dispatch => {
//   fetchAllOpportunitiesByAccount(accountID)
//     .then(response => {
//       // console.debug(response);
//       dispatch({
//         type: "OPPORTUNITIES_BY_ACCOUNT",
//         payload: response.Opportunities,
//       });
//     })
//     .catch(error => {
//       console.error(error);
//     });
// };

export const getAllPricebooks = () => dispatch =>
  new Promise((resolve, reject) => {
    getAllPricebooksService()
      .then(response => {
        dispatch({
          type: "LOAD_PRICELISTS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const getCreateQuoteInitData = category => async dispatch => {
  try {
    const docID = await generateDocumentID(category);
    const priceBooks = await getAllPricebooksService();

    return Promise.all([docID, priceBooks])
      .then(response => {
        dispatch({
          type: "LOAD_PRICELISTS",
          payload: response[1],
        });
        return response[0];
      })
      .catch(error => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/actions/OpportunitiesActions/opportunitiesActions.js